import { render, staticRenderFns } from "./AdminVip.vue?vue&type=template&id=54da82e8&scoped=true&"
import script from "./AdminVip.vue?vue&type=script&lang=js&"
export * from "./AdminVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da82e8",
  null
  
)

export default component.exports